
/**
 * Load required plugin.
 */
window.Lity = require('lity');

/**
 * Configure the plugin.
 */

+function($){
  page.registerVendor('Lity');

  page.initLity = function() {

    $(document).on('click', '[data-provide~="lightbox"]', Lity);

  }

}(jQuery);






//////////////////
// WEBPACK FOOTER
// ./src/assets/plugin/thesaas/js/vendors/lity.js
// module id = 52
// module chunks = 0